export default {
      id: "calc-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#calc-usage",
      toString: function () {
        return this.url;
      }
    }